module.exports = __webpack_public_path__ + "static/media/emersonLogo.6aa432fb.jpg";